<template>
  <div class="forget">
    <a-card style="width: 60%; margin: 50px auto">
      <div
        style="
          border-bottom: 2px solid #aaa;
          width: 100%;
          text-align: left;
          font-size: 20px;
        ">
        账号信息
      </div>
      <a-form :model="formData" layout="inline" class="form-class">
        <a-form-item label="用户名"  class="form-margin">
          <a-row >
            <a-col :span="18" >
                {{formData.username}}
              <!-- <a-input
                v-model:value="formData.username"
                placeholder="请输入用户名"
                style="width: 250px "
              ></a-input> -->
            </a-col>
            <!-- <a-col :span="6">
              <a-button @click="sendInfo">点击发送验证码</a-button>
            </a-col> -->
          </a-row>
        </a-form-item>
        <a-form-item
          label="邮箱："
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
                -
            </a-col>
          </a-row>
        </a-form-item>
         <a-form-item
          label="旧密码"
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
              <a-input-password
                v-model:value="formData.oldPassword"
                placeholder="请输入新密码"
                style="width: 572px"
              ></a-input-password>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          label="新密码"
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
              <a-input-password
                v-model:value="formData.password"
                placeholder="请输入新密码"
                style="width: 572px"
              ></a-input-password>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          label="再次输入"
          class="form-margin"
        >
          <a-row>
            <a-col :span="24">
              <a-input-password
                v-model:value="formData.isPassword"
                placeholder="请输入重复密码"
                style="width: 572px"
              ></a-input-password>
            </a-col>
          </a-row>
        </a-form-item>
        <a-row class="dban">
          <a-col style="checked: ref(false)">
            <a-button @click="cancelpass">取消</a-button>
          </a-col>
          &nbsp;&nbsp;&nbsp;
          <a-col :span="50">
            <a-button @click="onSubmit" type="primary" class="submit-class"> 确定 </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { message } from 'ant-design-vue';
import { changeCode } from '../../utils/api'
export default defineComponent({
  setup() {
    const formData = reactive({
      username:  localStorage.getItem('userName')?localStorage.getItem('userName'):'',
      encode: "",
      password: "",
      oldPassword:"",
      isPassword: "",
    });
    return {
      formData,
    };
  },
  methods:{
      cancelpass(){
           this.$router.go(-1)
      },
        onSubmit(){
            if(this.formData.oldPassword==''){
                message.error('请输入旧密码');
                return
            }
            if(this.formData.password==''){
                message.error('请输入新密码');
                return
            }
            if(this.formData.newPassword==''){
                message.error('请输入确认密码');
                return
            }
            if(this.formData.isPassword!=this.formData.password){
                message.error('两次密码不正确');
                return
            }
            changeCode({newPassword:this.formData.password,oldPassword:this.formData.oldPassword}).then(res=>{
                    if(res.code==200){
                        message.info('密码修改成功');
                        this.$router.push('indexLogin')
                    }
            })
        },
  }
});
</script>

<style lang="scss" scoped>
.forget{
  /deep/.ant-form-item-label{
    width: 100px;
  }
  .hoverBottomWapper{
      width: 100%;
      padding-bottom: 10px;
      .hoverBottom1{
        position: relative;
        width:100%;
        // text-align:center;
        //  padding:0px 0 10px 0;
        width:fit-content;
        margin: 0 auto;
        display: block;
        text-align:center;
         p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
      }
  }
  .form-class {
    display: flex;
    flex-direction: column;
  }
  .ant-row{
    text-align: left;
  }
  .form-margin {
    margin: 25px 20px 0 20px;
  }
  .dban {
    margin: 15px;
    margin-left: 510px ;
  }
  .ant-card{
    margin-top: 20px;
  }
}

</style>